export class LanguagesDB {

    public static languages = [
        "",
        "en",
        "en-GB",
        "es",
        "pt",
        "nl",
        "de",
        "it",
        "fr"
    ]
}